<app-steps [step]='1'></app-steps>

<div class="row">
  <div class="col-sm-12">
    <div class="card-deck">
      <form class="card bg-default" [formGroup]="form" (ngSubmit)="checkEmail()" novalidate>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <h3 class="main-title card-title">Login</h3>
              <div class="form-control-plaintext">
                Please use the Login option to utilise our Online Booking System.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>E-mail</mat-label>
                <input matInput formControlName="email" type="text">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput formControlName="password" type="password">
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col text-center">
              <button class="btn btn-blue" type="submit">Login</button>
              <a (click)="forgotPassword()" class="btn btn-secondary">Forgot your password?</a>
              <input type="submit" style="position:absolute;left: -10000px;">
            </div>
          </div>
          <br>
          <hr class="">
          <br>
          <p class="card-text"><strong><i class="fas fa-info-circle"></i>&nbsp;Existing Patient to Universal
              Health</strong></p>
          <p class="card-text">
            If you have not used our online booking system before, please enter your email and click on Login. An email validation link will be sent to your email.
          </p>
          <p class="card-text"> If your email is not recognised, then please contact us <a
              href="https://www.universalhealth.com.au/contact/" target="_blank">here</a> to add your current
            email address to
            your details </p>
        </div>
      </form>

      <div class="card bg-light">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <h3 class="main-title card-title">New to Universal Health</h3>
              <div class="form-control-plaintext">
                Please use the Register option to continue with your Initial Consultation Booking.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
            </div>
          </div>
          <div class="row">
            <div class="col">
            </div>
          </div>
          <div class="row">
            <div class="col">
            </div>
            <div class="col">
            </div>
          </div>
        </div>

        <div class="card-footer text-center">
          <a class="btn btn-blue" (click)="register()">Register</a>
        </div>
      </div>

    </div>
  </div>
</div>